import React from 'react'
import Button from '../../../atoms/Button/Button'
import FilterIcon from '../../../atoms/Icons/Controls/Configure'
import ContextMenu from '../../../molecules/ContextMenu/ContextMenu'
import styles from './DataFiltersMenu.module.scss'
import { IFilter, IOption } from '../DataFilters.types'

interface DataFiltersMenuProps {
  filters: IFilter[]
  onFilterSelect: (filterLabel: string, option: IOption) => void
}

interface DropdownButtonProps {
  state?: 'open' | 'close'
}

const DropdownButton: React.FC<DropdownButtonProps> = ({ state = 'open' }) => (
  <Button className={styles[`${state}-button`]} size="sm" secondary pill>
    <FilterIcon />
  </Button>
)

const DataFiltersMenu: React.FC<DataFiltersMenuProps> = ({ filters, onFilterSelect }) => {
  return (
    <div className={styles.root}>
      <ContextMenu
        name="filter-menu"
        items={filters.map(({ label, options }) => ({ label, subOptions: options }))}
        dropDownOpenIcon={<DropdownButton state="open" />}
        dropDownCloseIcon={<DropdownButton state="close" />}
        position="left"
        showInput={false}
        onSubmenuOptionClick={onFilterSelect}
      />
    </div>
  )
}

export default DataFiltersMenu
